module.exports = "/packs/ipad-e61165e899edc287732533154c67e786.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/packs/Shared/assets/images/ipad.png
// module id = ./app/javascript/packs/Shared/assets/images/ipad.png
// module chunks = 1